import { onError } from '@apollo/client/link/error'
import { captureException } from '~/lib/sentry/captureException'
import { getStatusCodeFromGraphQLErrors } from '~/utils/statusCode'
import cookies from 'js-cookie'
import getConfig from 'next/config'

const { TOKEN_COOKIE_NAME } = getConfig().publicRuntimeConfig
const filterErrors = ({ message }) => !['Invalid or expired login link'].includes(message)

const errorHandlerLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    const statusCode = getStatusCodeFromGraphQLErrors(graphQLErrors)

    if (statusCode === 401) {
      /**
       * If user is unauthorized when doing a query it usually means that the token is present but
       * has expired (tokens lifetime is 30 days). If this is the case we want to remove the token
       * and update the cache accordingly.
       *
       * TODO: Use a refresh token here to update the token
       */
      cookies.remove(TOKEN_COOKIE_NAME)

      const { cache } = operation.getContext()
      cache.reset()
    }

    graphQLErrors.filter(filterErrors).forEach(graphqlError => {
      captureException(new Error(graphqlError.message), 'graphql', {
        extra: {
          graphqlError,
          operation: operation.operationName,
          variables: operation.variables,
        },
      })
    })
  }

  if (networkError) {
    try {
      // Check if error response is JSON
      JSON.parse(networkError.bodyText)
    } catch {
      // If not, replace HTML error message because it is not readable.
      networkError.message = `Error while carrying out operation: ${operation.operationName}.`
      networkError.bodyText = ''

      console.error(
        `Error while trying to fetch from server. Have a look the resolver/mapper of operation: ${operation.operationName}`
      )
    }

    captureException(new Error(networkError.message), 'graphql', {
      extra: {
        networkError,
        operation: operation.operationName,
        variables: operation.variables,
      },
    })
  }
})

export default errorHandlerLink
